/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Commande pour recuperer un apercu du template email pour un lead
 * @export
 * @interface GetLeadTemplatePreviewCommand
 */
export interface GetLeadTemplatePreviewCommand {
    /**
     * ID du lead
     * @type {string}
     * @memberof GetLeadTemplatePreviewCommand
     */
    leadId: string;
    /**
     * ID du template Brevo (optionnel, defaut = 16)
     * @type {number}
     * @memberof GetLeadTemplatePreviewCommand
     */
    templateId?: number | null;
}

/**
 * Check if a given object implements the GetLeadTemplatePreviewCommand interface.
 */
export function instanceOfGetLeadTemplatePreviewCommand(value: object): value is GetLeadTemplatePreviewCommand {
    if (!('leadId' in value) || value['leadId'] === undefined) return false;
    return true;
}

export function GetLeadTemplatePreviewCommandFromJSON(json: any): GetLeadTemplatePreviewCommand {
    return GetLeadTemplatePreviewCommandFromJSONTyped(json, false);
}

export function GetLeadTemplatePreviewCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadTemplatePreviewCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'leadId': json['leadId'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
    };
}

export function GetLeadTemplatePreviewCommandToJSON(json: any): GetLeadTemplatePreviewCommand {
    return GetLeadTemplatePreviewCommandToJSONTyped(json, false);
}

export function GetLeadTemplatePreviewCommandToJSONTyped(value?: GetLeadTemplatePreviewCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadId': value['leadId'],
        'templateId': value['templateId'],
    };
}

